import { useMutation } from 'react-query'

import { WorkspaceExportOptions } from '../../../modules/workspace/workspace/types/wrokspace.types'
import { excelApi } from '../api/excel.api'

export const useExportExcel = () => {
  return useMutation(async (options: WorkspaceExportOptions) => {
    await excelApi.exportWorkspace(options)
  })
}
